
import React from 'react';
import { useLang } from '@/contexts/LangContext';
import { motion } from 'framer-motion';

const StatsSection = () => {
  const { t } = useLang();
  
  const statVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: (i: number) => ({
      opacity: 1,
      scale: 1,
      transition: {
        delay: i * 0.1,
        duration: 0.4
      }
    })
  };
  
  return (
    <div className="py-16 px-4 bg-black border-t border-gray-900 relative">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-2 text-white">
          {t.stats.title}
        </h2>
        <p className="text-center text-gray-300 mb-12">
          {t.stats.subtitle}
        </p>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
          {/* Stat 1 */}
          <motion.div 
            className="bg-black border border-gray-800 rounded-lg p-6 text-center"
            custom={0}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={statVariants}
          >
            <p className="text-4xl md:text-5xl font-bold mb-2" style={{ color: '#2fb8f8' }}>50K+</p>
            <p className="text-sm text-gray-400">{t.stats.activeUsers}</p>
          </motion.div>
          
          {/* Stat 2 */}
          <motion.div 
            className="bg-black border border-gray-800 rounded-lg p-6 text-center"
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={statVariants}
          >
            <p className="text-4xl md:text-5xl font-bold mb-2" style={{ color: '#2fb8f8' }}>$2M+</p>
            <p className="text-sm text-gray-400">{t.stats.tradingVolume}</p>
          </motion.div>
          
          {/* Stat 3 */}
          <motion.div 
            className="bg-black border border-gray-800 rounded-lg p-6 text-center"
            custom={2}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={statVariants}
          >
            <p className="text-4xl md:text-5xl font-bold mb-2" style={{ color: '#2fb8f8' }}>95%</p>
            <p className="text-sm text-gray-400">{t.stats.successRate}</p>
          </motion.div>
          
          {/* Stat 4 */}
          <motion.div 
            className="bg-black border border-gray-800 rounded-lg p-6 text-center"
            custom={3}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={statVariants}
          >
            <p className="text-4xl md:text-5xl font-bold mb-2" style={{ color: '#2fb8f8' }}>24/7</p>
            <p className="text-sm text-gray-400">{t.stats.support}</p>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
